import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { SectionHeader } from "../../../components/Shared";
import { statusColor, ScoreRing, MiniBar } from "./facilityHelpers";

const PredictivePanel = ({ d }) => (
  <div>
    <SectionHeader title="AI Predictive Maintenance" />
    <div className="fm-predict-grid">
      {d.equipment.map(eq => (
        <div key={eq.id} className={`fm-predict-card ${eq.failureRisk >= 80 ? "fm-predict-danger" : eq.failureRisk >= 50 ? "fm-predict-warn" : ""}`}>
          <div className="fm-predict-header">
            <div>
              <div className="fm-predict-name">{eq.name}</div>
              <div className="fm-predict-type">{eq.type}</div>
            </div>
            <div className="fm-predict-ring">
              <ScoreRing value={eq.healthScore} size={70} />
            </div>
          </div>

          {eq.aiAlert && (
            <div className="fm-ai-alert-box">
              <FiAlertTriangle size={14} />
              <span>{eq.aiAlert}</span>
            </div>
          )}

          <div className="fm-predict-metrics">
            <div className="fm-predict-row">
              <span className="fm-predict-lbl">Failure Risk</span>
              <span className="fm-predict-val" style={{ color: eq.failureRisk >= 70 ? "#ef4444" : eq.failureRisk >= 40 ? "#f59e0b" : "#10b981" }}>
                {eq.failureRisk}%
              </span>
            </div>
            <MiniBar value={eq.failureRisk} max={100} color={eq.failureRisk >= 70 ? "#ef4444" : eq.failureRisk >= 40 ? "#f59e0b" : "#10b981"} />
            <div className="fm-predict-row" style={{ marginTop: "0.5rem" }}>
              <span className="fm-predict-lbl">Est. Failure</span>
              <span className="fm-predict-val">{eq.daysToFailure} days</span>
            </div>
            <div className="fm-predict-row">
              <span className="fm-predict-lbl">Vibration</span>
              <span className="fm-predict-val" style={{ color: statusColor(eq.vibration) }}>{eq.vibration}</span>
            </div>
            <div className="fm-predict-row">
              <span className="fm-predict-lbl">Noise Pattern</span>
              <span className="fm-predict-val" style={{ color: eq.noise === "Abnormal" ? "#ef4444" : "#10b981" }}>{eq.noise}</span>
            </div>
            <div className="fm-predict-row">
              <span className="fm-predict-lbl">Last Service</span>
              <span className="fm-predict-val">{eq.lastService}</span>
            </div>
            <div className="fm-predict-row">
              <span className="fm-predict-lbl">Next Service</span>
              <span className="fm-predict-val" style={{ color: eq.nextService.includes("Overdue") ? "#ef4444" : "#374151" }}>{eq.nextService}</span>
            </div>
          </div>

          {eq.parts.length > 0 && (
            <div className="fm-parts-list">
              <span className="fm-parts-lbl">Recommended Parts:</span>
              {eq.parts.map((p, i) => <span key={i} className="fm-part-chip">{p}</span>)}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default PredictivePanel;
